export default [
  '#3F51B5',
  '#DF81A9',
  '#F6669A',
  '#F9678B',
  '#A53DEF',
  '#FBB76F',
  '#E9AC91',
  '#F99185',
  '#45DDB8',
  '#21AE92',
  '#00C6CE',
  '#398AE3',
  '#3B9DE2',
  '#103573',
  '#4E4F50',
  '#1D1F20',
];
